module.exports = __webpack_public_path__ + "static/img/big1.9afbbe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big1.png
// module id = 0I6q
// module chunks = 1